import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import { dayjs } from 'util/shared/date';

/** The conversation-storage backend's timestamp format uses dashes in the time
 * portion (e.g. "2026-08-27T14-04-10.123"), so it isn't directly ISO-8601 parseable.
 * It's also always UTC, so convert to the viewer's own timezone for display. */
export function parseConversationTimestamp(
  timestamp: string | null | undefined,
): ReturnType<typeof dayjs> {
  // Falls back to "now" for a response missing this field (e.g. a backend a version
  // behind), rather than crashing the whole sidebar over one display timestamp.
  if (timestamp == null) {
    return dayjs();
  }
  return dayjs
    .utc(timestamp.replace(/T(\d{2})-(\d{2})-(\d{2})/, 'T$1:$2:$3'))
    .local();
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
export function chatChunkMergeCustomizer(objValue: any, srcValue: any): any {
  if (typeof objValue === 'string' && typeof srcValue === 'string') {
    if (objValue == srcValue) {
      return objValue;
    } else {
      return objValue + srcValue;
    }
  }
  if (isArray(objValue) && isArray(srcValue)) {
    let objIdx = 0;
    let srcIdx = 0;
    let objItem = objValue[objIdx++];
    let srcItem = srcValue[srcIdx++];
    const result = [];
    while (objItem != null || srcItem != null) {
      if (
        objItem != null &&
        (srcItem == null ||
          objItem.index == null ||
          objItem.index < srcItem.index)
      ) {
        result.push(objItem);
        objItem = objValue[objIdx++];
      } else if (
        srcItem != null &&
        (objItem == null ||
          srcItem.index == null ||
          srcItem.index < objItem.index)
      ) {
        result.push(srcItem);
        srcItem = srcValue[srcIdx++];
      } else if (objItem.index == srcItem.index) {
        result.push(mergeWith(objItem, srcItem, chatChunkMergeCustomizer));
        objItem = objValue[objIdx++];
        srcItem = srcValue[srcIdx++];
      } else if (objItem != null) {
        result.push(objItem);
        objItem = objValue[objIdx++];
      } else {
        result.push(srcItem);
        srcItem = srcValue[srcIdx++];
      }
    }
    return result;
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
